import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { connect } from 'react-redux';
import setSearchFirmAction from '../../redux/actions/searchReferenceActions/actionSearchFirm';
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-notchedOutline': {
      '&:hover': {
        borderColor: "rgb(0,191,255)",
      },
      '&.Mui-focused': {
        borderColor: "rgb(47, 79, 79)",
      },
    },
    '& .Mui-focused': {
      color: 'white',
    },
    width: 300,
    marginTop: 10,
    fontSize: 30,
    backgroundColor: 'rgba(19, 174, 236, 0.54)',
    fontWeight: 'bold'
  });

class SearchFrimForm extends React.Component {

    constructor(props) {
        super(props);
            this.state = {
                firm: '', firms: [
                    { firm: 'MC', nr: '001' },
                    { firm: 'Botament', nr: '006' },
                ]
            }

        this.props.setSearchFirmFunction('');
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeForm = this.handleChangeForm.bind(this)
    }

    handleChangeForm = (event, value) => {
        if (value !== null) {
            this.setState({ firm: value }, () => {
                this.props.setSearchFirmFunction(this.state.firm);
            });
        } else {
            this.setState({ firm: '' }, () => {
                this.props.setSearchFirmFunction(this.state.firm);
            });
        }
    }

    handleChange(event, value) {

        if (event.target.value.length > 0) {
            this.setState({ firm: event.target.value });
        }
    }

    render() {

        const { classes } = this.props;
        const { t } = this.props;

        return (
            <div>
                <Autocomplete
                    classes={classes}
                    id="combo-box-FOE"
                    autoComplete={true}
                    onChange={this.handleChangeForm}
                    options={this.state.firms}
                    isOptionEqualToValue={(option, value) => option.firm === value.firm}
                    getOptionLabel={(option) => option.firm}
                    noOptionsText={'Wrong input data'}
                    renderInput={(params) => <StyledTextField {...params} onChange={this.handleChange} style={{ fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)', width: 300, marginTop: 10 }}
                        label={t('search_ref.search_firm')} variant="outlined" />}
                />
            </div>
        );

    }
}

function mapDispatchToProps(dispatch) {
    return {
        setSearchFirmFunction: searchFirm => {
            dispatch(setSearchFirmAction(searchFirm))
        }
    }
}

export default connect(null, mapDispatchToProps)(withTranslation()(SearchFrimForm));